import { getCurrentDomain } from '../../host';

export default {
  necessary: {
    enabled: true,
    readOnly: true,
  },
  analytics: {
    enabled: false,
    readOnly: false,
    autoClear: {
      cookies: [
        // ANY.RUN
        { name: 'user_id', domain: `.${getCurrentDomain()}`, path: '/' },

        // Growthbook
        { name: 'gbuuid', domain: `.${getCurrentDomain()}`, path: '/' },
      ],
    },
  },
  functional: {
    enabled: false,
    readOnly: false,
    autoClear: {
      cookies: [
        // Mailer Lite (blog)
        { name: 'mailerlite:forms:submitted', domain: `${getCurrentDomain()}`, path: '/' },
        { name: 'mailerlite:forms:shown', domain: `${getCurrentDomain()}`, path: '/' },
      ],
    },
  },
  marketing: {
    enabled: false,
    readOnly: false,
    autoClear: {
      cookies: [
        // ANY.RUN
        { name: 'utm_parameters', domain: `.${getCurrentDomain()}`, path: '/' },
        { name: 'li_fat_id', domain: `.${getCurrentDomain()}`, path: '/' },
        { name: 'FPGCLAW', domain: `.${getCurrentDomain()}`, path: '/' },
      ],
    },
  },
};
